import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-respac",
  "use": "icon-respac-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-respac\"><defs><style type=\"text/css\"></style></defs><path d=\"M546.525867 500.292267c6.075733-90.589867 85.504-158.958933 176.298666-158.958934H853.333333a34.133333 34.133333 0 0 0 34.133334-34.133333v-136.533333c0-37.546667-30.72-68.266667-68.266667-68.266667H68.266667c-37.546667 0-68.266667 30.72-68.266667 68.266667v682.666666c0 37.546667 30.72 68.266667 68.266667 68.266667h750.933333c37.546667 0 68.266667-30.72 68.266667-68.266667v-136.533333a34.133333 34.133333 0 0 0-34.133334-34.133333h-136.533333c-97.979733 0-176.930133-82.9952-170.274133-182.3744z\" p-id=\"27474\" /><path d=\"M921.6 409.6H716.8a102.4 102.4 0 1 0 0 204.8h204.8a102.4 102.4 0 1 0 0-204.8z\" p-id=\"27475\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/respac.svg
// module id = sybz
// module chunks = 12